export default "__VITE_ASSET__CSBl$eUQ__"